// extracted by css-extract-rspack-plugin
export default {"root":"k_p5oR","scrollable":"VAC19A","size-small":"vj85zh","sizeSmall":"vj85zh","size-medium":"KVzYJT","sizeMedium":"KVzYJT","tag-item":"gzifZC","tagItem":"gzifZC"};